import { useMemo } from "react";

import { TalkRatioListProps } from "./TalkRatioList.decl";
import { TalkRatioListItem } from "./TalkRatioListItem";

function byTotalDesc([, aTotal]: number[], [, bTotal]: number[]): number {
  return bTotal > aTotal ? 1 : -1;
}

export function TalkRatioList({ talkRatio, speakers }: TalkRatioListProps) {
  const sorted = useMemo(
    () => [...talkRatio.entries()].sort(byTotalDesc),
    [talkRatio]
  );

  if (!speakers) {
    return null;
  }

  return (
    <div className="flex w-full flex-col gap-1">
      {sorted.map(([channel, ratio], index) => (
        <TalkRatioListItem
          speakers={speakers}
          channel={channel}
          ratio={ratio}
          index={index}
          key={channel}
        />
      ))}
    </div>
  );
}
